import React from 'react';
import Chart from '../../media/chart.jpg';
import classes from './style.module.scss';
import Footer from '../Footer/Footer';

const Plan = () => {
    return (
        <div className={classes.page}>
            <div className={classes.container}>
                <div>
                    <div className={classes.imageContainer}>
                        <img src={Chart} alt="chart" />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Plan;
